<template>
  <div class="view-lesson-meetpy-5">
    <div class="d-flex w-100 justify-content-center">
      <div id="meetingSDKElement"></div>
    </div>

    <zoom-messages
      v-model="message_visible"
      :message="message"
      :type="message_type"
      :loading="loading"
      @close="message_visible = false"
    />
  </div>
</template>

<script>
import ZOOM_ERROR_MESSAGE from "@/components/lesson/ZOOM_ERROR_MSG_MAP.js";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import ZoomMessages from "./ZoomMessages.vue";

import get from "lodash/get";
export default {
  components: { ZoomMessages },
  props: {
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    ZoomMtgEmbedded.destroyClient();
    const width =
      window.innerWidth > 991 ? 1000 : Number(window.innerWidth / 2);
    const height = (width * 9) / 16;
    return {
      loading: true,
      message: "",
      message_type: "",
      message_visible: true,
      client: ZoomMtgEmbedded.createClient(),
      joinOptions: {
        signature: get(this.lesson, "meeting_config.signature", ""),
        meetingNumber: get(this.lesson, "meeting_config.meeting_id", ""),
        userName: this.$user.user.name,
        sdkKey: get(this.lesson, "meeting_config.client_id", ""),
        userEmail: this.$user.user.email,
        password: get(this.lesson, "meeting_password", "")
      },
      initOptions: {
        language: "pt-PT",
        sharingMode: "fit",
        defaultView: "gallery",
        customize: {
          meetingInfo: [
            "topic",
            "host",
            "mn",
            "pwd",
            "telPwd",
            "invite",
            "participant",
            "dc",
            "enctype"
          ],
          activeApps: {
            popper: {
              placement: "bottom"
            }
          },
          chat: {
            popper: {
              placement: "bottom"
            }
          },
          meeting: {
            popper: {
              placement: "bottom"
            }
          },
          setting: {
            popper: {
              placement: "bottom"
            }
          },
          participants: {
            popper: {
              placement: "bottom"
            }
          },
          video: {
            isReziseable: true,
            viewSizes: {
              default: {
                width,
                height
              }
            }
          }
        }
      }
    };
  },
  mounted() {
    this.showMessage({
      msg: "Preparando a sala para a aula ao vivo!",
      type: "success"
    });
    setTimeout(() => {
      this.loadMeeting();
    }, 2000);
  },
  methods: {
    async loadMeeting() {
      try {
        const requirements = this.client.checkSystemRequirements();

        this.showMessage({
          msg: "Verificando requisitos do sistema",
          type: "info"
        });

        if (requirements.audio && requirements.video) {
          const zoomAppRoot = document.getElementById("meetingSDKElement");

          await this.client.init({
            zoomAppRoot,
            ...this.initOptions,
            error: e => {
              throw new Error(`Init: ${e}`);
            }
          });

          this.showMessage({ msg: "Entrando na chamada...", type: "info" });

          await this.client.join({
            ...this.joinOptions,
            success: () => {
              this.showMessage({ msg: "Tudo pronto!", type: "success" });
            },
            error: e => {
              throw new Error(`Join: ${e}`);
            }
          });

          window.clientZoom = this.client;
          document.addEventListener("beforeunload", () => {
            window.clientZoom.leaveMeeting();
          });
        } else {
          this.showMessage({
            msg:
              "Desculpe, seu navegador não é compatível com chamadas do Zoom na web",
            type: "error"
          });
        }
      } catch (e) {
        if (ZOOM_ERROR_MESSAGE[e.errorCode]) {
          this.showMessage({
            msg: ZOOM_ERROR_MESSAGE[e.errorCode],
            type: "info"
          });
        } else {
          this.showMessage({
            msg:
              "Não foi possível entrar na chamada. Entre em contato com o suporte!",
            type: "error"
          });
        }
      } finally {
        this.loading = false;
      }
    },
    showMessage(data) {
      this.message = data.msg || "";
      this.message_type = data.type || "success";
      this.message_visible = true;

      setTimeout(() => {
        this.message_visible = false;
      }, 8000);
    }
  }
};
</script>

<style lang="scss">
.view-lesson-meet {
  display: flex;
  position: relative;
}
#meetingSDKElement {
  justify-content: center;
  display: contents !important;
  > div:first-of-type {
    width: -webkit-fill-available;
    justify-content: center;
  }
}
#suspension-view-tabpanel-active-active {
  > div:first-of-type {
    height: 500px;
    @media screen and (max-width: 991px) {
      height: 300px;
    }
    @media screen and (max-width: 767px) {
      height: 250px;
    }
  }
}
.react-resizable {
  .MuiPaper-root:nth-child(1) {
    width: 100%;
  }
}
</style>
